import script from "./ShotEditing.vue?vue&type=script&setup=true&lang=js"
export * from "./ShotEditing.vue?vue&type=script&setup=true&lang=js"

import "./ShotEditing.vue?vue&type=style&index=0&id=f3c74864&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3c74864"]])

export default __exports__